import { toggleLinkRowClasses } from './utils.js'

let $containers = document.querySelectorAll('.js-filter')
let $items
let $buttons

if ($containers.length) {
  Array.from($containers).forEach(init)
}

function init($container) {
  let $things = Array.from($container.querySelectorAll('[data-filter]'))
  $buttons = $things.filter(x => x.nodeName === 'BUTTON')
  $items = $things.filter(x => x.nodeName !== 'BUTTON')
  if ($buttons && $buttons.length > 0) {
    filterItems($buttons[0].getAttribute('data-filter'))
    $buttons.forEach($button => {
      $button.addEventListener('click', handleClick)
    })
  }
}

function handleClick(e) {
  let $button = e.target.closest('button')
  filterItems($button.getAttribute('data-filter'))

  toggleLinkRowClasses($buttons, $button)
}

function filterItems(filter) {
  $items.forEach($item => {
    if (
      $item
        .getAttribute('data-filter')
        .split(',')
        .indexOf(filter) !== -1
    ) {
      $item.hidden = false
    } else {
      $item.hidden = true
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/_filter.js